import { REDUX_ACTIONS } from "constants/constants";

const initialState = {
  name: "",
};

const vmDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.FETCH_VM_DETAILS:
      return action.payload;
    case REDUX_ACTIONS.RESET_VM_DETAILS:
      return initialState;
    default:
      return state;
  }
};

export default vmDetailsReducer;
